angular.module('bmsApp.sm.quote')
	.controller('SMQuoteViewCtrl', function ($state,
											 $scope,
											 $q,
											 NoteSvc,
											 EmailSvc,
											 $ngBootbox,
											 SMJobSvc,
											 notify,
											 SMJobDocumentSvc,
											 $window,
											 TaxHelperSvc,
											 NoteSvc,
											 EmailSvc) {

		function init() {
			self.quoteId = $state.params.quoteId;
			$q.all({
				quote: SMJobSvc.read(self.quoteId),
				vatRate: TaxHelperSvc.setVatRate()
			})
				.then(function (responses) {
					self.quote = responses.quote.data.sm_job;
					self.loading = false;
					angular.extend($scope, {
						quote: {
							name: angular.copy(self.quote.quote_name)
						}
					});
					self.loading = false;
				});
		}

		function addNote() {
			var note = {
				object_type: 'App\\Models\\Sm\\Job',
				object_id: self.quoteId
			};
			NoteSvc.showSaveModal(note);
		}

		function copyQuote() {
			SMJobSvc.showCopyQuoteModal(self.quote)
				.then(function (result) {
					notify({
						message: 'Successfully copied'
					});
					$state.go('main.sm.quote.index.view', {quoteId: result.id});
				});
		}

		function deleteQuote() {
			$ngBootbox.confirm('Are you sure you want to completely remove this quote?')
				.then(function () {
					SMJobSvc.delete(self.quote)
						.then(function () {
							notify({
								message: 'Successfully removed quote'
							});
							$state.go('main.sm.quote.index');
						}, function (errors) {
							self.errors = errors;
						})
				});

		}

		function emailForm(emailAddress, objectType, objectId) {
			var email = {
				to: emailAddress,
				object_type: objectType,
				object_id: objectId
			};
			EmailSvc.showSendModal(email, self.quote.customer);
		}

		function viewDocument(document) {
			$window.open('file/download/'+document.filename, '_blank');
		}

		function deleteDocument(document, $index) {
			$ngBootbox.confirm('Are you sure you want to completely remove this risk assessment document?')
				.then(function () {
					SMJobDocumentSvc.delete({
						filename: document.filename
					}).then(function() {
						self.quote.documents.splice($index, 1);
					});
				});
		}

		var self = $scope.SMQuoteViewCtrl = {
			loading: true,
			methods: {
				init: init,
				emailForm: emailForm,
				addNote: addNote,
				copyQuote: copyQuote,
				deleteQuote: deleteQuote,
				viewDocument: viewDocument,
				deleteDocument: deleteDocument
			}
		};


	});
